import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

interface NetRevenueRowPayload {
  id?: string;
}

interface NetRevenueCostProfilePayload extends NetRevenueRowPayload {
  name: string | null;
}

interface NetRevenueStayDatePayload extends NetRevenueRowPayload {
  date: string;
}

interface NetRevenueDashboardPayload {
  cost_profiles?: NetRevenueCostProfilePayload[];
  id: string;
  stay_date?: NetRevenueStayDatePayload[];
  total?: NetRevenueRowPayload;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class NetRevenueDashboardSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    total: { embedded: 'always' },
    costProfiles: { embedded: 'always' },
    stayDate: { embedded: 'always' },
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'net_revenue_periods') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('net-revenue/dashboard');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(typeClass: ModelSchema, resourceHash: NetRevenueDashboardPayload) {
    const periodId = resourceHash.id;

    if (resourceHash.total) {
      resourceHash.total.id = `${periodId}:total`;
    }

    resourceHash.cost_profiles?.forEach((profile) => {
      profile.id = `${periodId}:cost-profile:${profile.name ?? 'remaining'}`;
    });

    resourceHash.stay_date?.forEach((point) => {
      point.id = `${periodId}:stay-date:${point.date}`;
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, resourceHash);
  }
}
